export const isFloorplannerDebugLoggingEnabled = (): boolean => {
  if (process.env.REACT_APP_FLOORPLANNER_DEBUG_LOGS === "1") {
    return true;
  }

  if (typeof window === "undefined") {
    return false;
  }

  const params = new URLSearchParams(window.location.search);
  return params.get("debug") === "1" || params.get("debugLogs") === "1";
};
